import * as actionTypes from './actionTypes';
import * as baseAction from './baseAction';

import { sanitizeFranchiseData, sanitizePhoneNumber } from '../../lib/Sanitizer';
import { formatPhoneNumber } from '../../lib/Formatter';

export const franchiseStart = (accessToken, data) => baseAction.actionStart(actionTypes.FRANCHISE_START, accessToken, data);
export const franchiseSuccess = (data) => baseAction.actionSuccess(actionTypes.FRANCHISE_SUCCESS, data);
export const franchiseFail = (error) => baseAction.actionFail(actionTypes.FRANCHISE_FAIL, error);

export const franchiseSelect = (options) => {
    return (dispatch, getState) => {
        if (options && options.franchiseId) {
            baseAction.actionExecute(dispatch, getState, {
                url: `/Franchise/${options.franchiseId}`,
                startFn: (accessToken) => dispatch(franchiseStart(accessToken, { lastScope: 'select' })),
                successFn: (response) => dispatch(franchiseSuccess({ franchise: formatData(response.data), isNew: false })),
                failFn: (error) => dispatch(franchiseFail(error))
            });
        } else {
            dispatch(franchiseSuccess({ franchise: null, isNew: true }));
        }
    };
};

export const franchiseList = () => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            url: '/Franchise',
            startFn: (accessToken) => dispatch(franchiseStart(accessToken, { lastScope: 'list' })),
            successFn: (response) => dispatch(franchiseSuccess({ franchises: response.data })),
            failFn: (error) => dispatch(franchiseFail(error))
        });
    };
};

export const franchiseCreate = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'create',
            url: '/Franchise',
            payload: sanitizeFranchiseData(options.data),
            startFn: (accessToken) => dispatch(franchiseStart(accessToken, { lastScope: 'create' })),
            successFn: (response) => dispatch(franchiseSuccess({ franchise: formatData(response.data), isNew: false })),
            failFn: (error) => dispatch(franchiseFail(error))
        });
    };
};

export const franchiseUpdate = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'update',
            url: `/Franchise/${options.franchiseId}`,
            payload: sanitizeFranchiseData(options.data),
            startFn: (accessToken) => dispatch(franchiseStart(accessToken, { lastScope: 'update' })),
            successFn: (response) => dispatch(franchiseSuccess({ franchise: formatData(response.data), isNew: false })),
            failFn: (error) => dispatch(franchiseFail(error))
        });
    };
};

export const franchiseDelete = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'delete',
            url: `/Franchise/${options.franchiseId}`,
            startFn: (accessToken) => dispatch(franchiseStart(accessToken, { lastScope: 'delete' })),
            successFn: () => dispatch(franchiseSuccess({ franchise: null, isNew: false })),
            failFn: (error) => dispatch(franchiseFail(error))
        })
    };
};

export const franchiseDeleteRoyaltyPlan = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'delete',
            url: `/Franchise/${options.franchiseId}/RoyaltyPlanTemplate`,
            startFn: (accessToken) => dispatch(franchiseStart(accessToken, { lastScope: 'delete' })),
            successFn: (response) => dispatch(franchiseSuccess({ franchise: formatData(response.data), isNew: false })),
            failFn: (error) => dispatch(franchiseFail(error))
        })
    };
};

export const franchiseAssignRoyaltyPlan = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'put',
            url: `/Franchise/${options.franchiseId}/RoyaltyPlanTemplate/${options.royaltyPlanTemplateId}`,
            startFn: (accessToken) => dispatch(franchiseStart(accessToken, { lastScope: 'assign' })),
            successFn: (response) => dispatch(franchiseSuccess({ franchise: formatData(response.data), isNew: false })),
            failFn: (error) => dispatch(franchiseFail(error))
        })
    };
};

export const franchiseGeocode = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'put',
            url: `/Franchise/UpdateGeocode/${options.franchiseId}`,
            startFn: (accessToken) => dispatch(franchiseStart(accessToken, { lastScope: 'geocode' })),
            successFn: (response) => dispatch(franchiseSuccess({ franchise: formatData(response.data), isNew: false })),
            failFn: (error) => dispatch(franchiseFail(error))
        })
    };
};

export const franchiseOffices = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'get',
            url: `/BranchOffice/Franchise/${options.franchiseId}`,
            startFn: (accessToken) =>
                dispatch(
                    franchiseStart(accessToken, {
                        lastScope: 'franchiseOffices'
                    })
                ),
            successFn: (response) => {
                dispatch(
                    franchiseSuccess({
                        franchiseOffices: response.data
                    })
                );
            },
            failFn: (error) => dispatch(franchiseFail(error))
        });
    };
};

const formatData = (value) => {
    if (value) {
        if (value.primaryPhone) {
            value.primaryPhone = formatPhoneNumber(value.primaryPhone);
        }

        if (value.alternatePhone) {
            value.alternatePhone = formatPhoneNumber(value.alternatePhone);
        }
    }

    return value;
};